"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttrService = void 0;
var AttrService = /** @class */ (function () {
    function AttrService() {
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    AttrService.prototype.data = function (el, attr) {
        var data = el === null || el === void 0 ? void 0 : el.dataset[attr
            .split('-')
            .reduce(function (prev, current) { return "" + prev + current.charAt(0).toUpperCase() + current.slice(1); })];
        el === null || el === void 0 ? void 0 : el.removeAttribute("data-" + attr);
        try {
            return JSON.parse(data);
        }
        catch (e) {
            return data;
        }
    };
    AttrService.prototype.attr = function (el, attr) {
        var data = el.getAttribute(attr);
        el.removeAttribute(attr);
        return data;
    };
    return AttrService;
}());
var service = new AttrService();
exports.AttrService = service;
